import React from 'react';
import { useState, useEffect } from 'react';
import { language } from './components/locale/config';

import { GlobalStyle } from './styles/global';
import { Header } from './components/header';
import { Introduction } from './components/introduction';
import { Menu } from './components/menu';
import { Timeline } from './components/timeline';
import { Timeline_ru } from './components/timeline_ru';
import { SideMenu } from './components/side_menu';
import { Footer } from './components/footer';
import { ScrollToTop } from './components/scroll-to-top';

function App() {
  const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);
  const [isTimelineOpen, setIsTimelineOpen] = useState(false);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [timelineAnchor, setTimelineAnchor] = useState(1);
  const [scrollUp, setScrollUp] = useState(false);
  const openTimeline = (index: number) => {
    setScrollUp(false);
    setIsTimelineOpen(true);
    console.log(isTimelineOpen);
    setTimeout(() => {
      document.getElementById('chapter-' + index)?.scrollIntoView();
    }, 50);
  };
  const moveLeft = () => {
    setScrollUp(true);
    setIsTimelineOpen(true);
    setTimeout(() => {
      if (timelineAnchor !== 1) {
        document
          .getElementById('chapter-' + (timelineAnchor - 1))
          ?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  };

  const moveRight = () => {
    setScrollUp(false);
    setIsTimelineOpen(true);
    setTimeout(() => {
      if (timelineAnchor !== 9) {
        document
          .getElementById('chapter-' + (timelineAnchor + 1))
          ?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  };
  const handleSideMenu = (index: number) => {
    if (timelineAnchor >= index) {
      setScrollUp(false);
    } else {
      setScrollUp(true);
    }
    document
      .getElementById('chapter-' + index)
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScroll = (e: any) => {
    if (
      document.getElementById('chapter-1')!.getBoundingClientRect().top <=
      -window.innerWidth / 2
    ) {
      setIsSideMenuOpen(true);
    } else {
      setIsSideMenuOpen(false);
    }
    setTimelineAnchor(1);
    for (var i = 2; i < 10; i++) {
      if (
        document.getElementById('chapter-' + i)!.getBoundingClientRect().top <=
        1
      ) {
        setTimelineAnchor(i);
      }
    }
    if (
      document.getElementById('chapter-1')!.getBoundingClientRect().top <= 1
    ) {
      setIsHeaderMenuOpen(isTimelineOpen);
    } else {
      setIsHeaderMenuOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', (e: any) => handleScroll(e));
    return () =>
      window.removeEventListener('scroll', (e: any) => handleScroll(e));
  }, [isTimelineOpen]);

  return (
    <>
      <Header
        isHeaderMenuOpen={isHeaderMenuOpen}
        timelineAnchor={timelineAnchor}
        handleLeft={() => moveLeft()}
        handleRight={() => moveRight()}
      />
      <ScrollToTop isTimelineOpen={isTimelineOpen}>
        <Introduction />
        <Menu handleOpenTimeline={(index) => openTimeline(index)} />
      </ScrollToTop>
      {language === 'ua' ? (
        <Timeline scrollUp={scrollUp} isOpen={isTimelineOpen} />
      ) : (
        <Timeline_ru scrollUp={scrollUp} isOpen={isTimelineOpen} />
      )}

      <SideMenu
        timelineAnchor={timelineAnchor}
        isOpen={isSideMenuOpen}
        onClick={(index) => handleSideMenu(index)}
      />
      <Footer />
    </>
  );
}

export default App;
